import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.CART_PAGE]: {
    [ROLE.DIALOG]: [
      ELEMENT.SHARE,
      ELEMENT.IMPORT,
      ELEMENT.SELLER_CODE,
      ELEMENT.COUPON,
      ELEMENT.ZIPCODE,
      ELEMENT.BUDGET,
      ELEMENT.PREORDER,
      ELEMENT.SERVICE,
      ELEMENT.WARRANTY,
    ],
    [ROLE.CARD]: [ELEMENT.CART_ITEM],
  },
  [CONTEXT.CART_EMPTY]: {
    [ROLE.BUTTON]: [ELEMENT.GO_HOME],
  },
  [CONTEXT.CART_MENU]: {
    [ROLE.BUTTON]: [ELEMENT.SHARE, ELEMENT.IMPORT, ELEMENT.SELLER_CODE, ELEMENT.MENU_LIST],
    [ROLE.LIST]: [ELEMENT.MENU_LIST],
  },
  [CONTEXT.CART_SHARE]: {
    [ROLE.LINK]: [ELEMENT.IMPORT],
    [ROLE.BUTTON]: [ELEMENT.WHATSAPP, ELEMENT.COPY, ELEMENT.COPY_CODE],
    [ROLE.TEXT]: [ELEMENT.CODE],
  },
  [CONTEXT.CART_IMPORT]: {
    [ROLE.TEXTBOX]: [ELEMENT.CODE],
    [ROLE.BUTTON]: [ELEMENT.SUBMIT],
  },
  [CONTEXT.CART_SCHEDULE]: {
    [ROLE.BUTTON]: [ELEMENT.CONFIRM],
  },
  [CONTEXT.CART_SELLER_CODE]: {
    [ROLE.TEXTBOX]: [ELEMENT.CODE],
    [ROLE.BUTTON]: [ELEMENT.DELETE, ELEMENT.SUBMIT],
  },
  [CONTEXT.CART_INTERN_VIEW]: {
    [ROLE.TEXTBOX]: [ELEMENT.PRODUCT, ELEMENT.SELLER_CODE, ELEMENT.INSTALL_CODE],
    [ROLE.BUTTON]: [
      ELEMENT.LOGOUT,
      ELEMENT.CLEAN,
      ELEMENT.PRODUCT,
      ELEMENT.SELLER_CODE_ADD,
      ELEMENT.SELLER_CODE_REMOVE,
      ELEMENT.INSTALL_CODE_ADD,
      ELEMENT.INSTALL_CODE_REMOVE,
      ELEMENT.BUDGET,
      ELEMENT.PREORDER,
    ],
  },
  [CONTEXT.CART_PREORDER]: {
    [ROLE.TEXTBOX]: [ELEMENT.EMAIL],
    [ROLE.BUTTON]: [ELEMENT.SUBMIT],
  },
  [CONTEXT.CART_BUDGET]: {
    [ROLE.RADIO]: [
      ELEMENT.PJ,
      ELEMENT.PF,
      ELEMENT.WHATSAPP,
      ELEMENT.SMS,
      ELEMENT.OFFICIAL_CHANNELS,
    ],
    [ROLE.TEXTBOX]: [ELEMENT.EMAIL, ELEMENT.PHONE, ELEMENT.DOCUMENT, ELEMENT.NAME],
    [ROLE.LISTBOX]: [ELEMENT.CAMPAIGN],
    [ROLE.BUTTON]: [ELEMENT.COPY, ELEMENT.SUBMIT],
  },
  [CONTEXT.CART_ITEM]: {
    [ROLE.TEXT]: [
      ELEMENT.NAME,
      ELEMENT.SELLER,
      ELEMENT.PRICE,
      ELEMENT.SERVICE_PRICE,
      ELEMENT.WARRANTY_PRICE,
      ELEMENT.FREIGHT_PRICE,
      ELEMENT.SERVICE_SCHEDULE,
    ],
    [ROLE.BUTTON]: [ELEMENT.REMOVE, ELEMENT.QUANTITY, ELEMENT.BENEFITS],
    [ROLE.TEXTBOX]: [ELEMENT.QUANTITY],
    [ROLE.CONTAINER]: [ELEMENT.SERVICE, ELEMENT.WARRANTY],
    [ROLE.SWITCH]: [ELEMENT.SERVICE, ELEMENT.WARRANTY],
    [ROLE.FLAG]: [ELEMENT.PRICE],
  },
  [CONTEXT.CART_SERVICE]: {
    [ROLE.TEXT]: [ELEMENT.PRICE],
    [ROLE.BUTTON]: [ELEMENT.NOT_NOW, ELEMENT.CONFIRM],
  },
  [CONTEXT.CART_WARRANTY]: {
    [ROLE.RADIO]: [ELEMENT.WARRANTY],
    [ROLE.TEXT]: [ELEMENT.PRICE],
    [ROLE.BUTTON]: [ELEMENT.NOT_NOW, ELEMENT.CONFIRM],
  },
  [CONTEXT.CART_COUPON]: {
    [ROLE.TEXTBOX]: [ELEMENT.CODE],
    [ROLE.BUTTON]: [ELEMENT.SUBMIT],
  },
  [CONTEXT.CART_ZIPCODE]: {
    [ROLE.LINK]: [ELEMENT.ZIPCODE],
    [ROLE.TEXTBOX]: [ELEMENT.ZIPCODE],
    [ROLE.BUTTON]: [ELEMENT.SUBMIT],
  },
  [CONTEXT.CART_SUMMARY]: {
    [ROLE.LINK]: [
      ELEMENT.ADD_COUPON,
      ELEMENT.REMOVE_COUPON,
      ELEMENT.ADD_ZIPCODE,
      ELEMENT.CHANGE_ZIPCODE,
    ],
    [ROLE.BUTTON]: [ELEMENT.CONTINUE],
    [ROLE.TEXT]: [
      ELEMENT.PRODUCTS_QUANTITY,
      ELEMENT.PRODUCTS_PRICE,
      ELEMENT.COUPON,
      ELEMENT.COUPON_VALUE,
      ELEMENT.SUBTOTAL_PRICE,
      ELEMENT.SERVICES_QUANTITY,
      ELEMENT.SERVICES_PRICE,
      ELEMENT.WARRANTIES_QUANTITY,
      ELEMENT.WARRANTIES_PRICE,
      ELEMENT.FREIGHT_PRICE,
      ELEMENT.TOTAL_PRICE,
    ],
  },
} as TValidTestId;
